import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Text } from '@as/cotopaxi';
export const EticketFooter = ({ mainWebShop }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    return (_jsxs(Text, { children: [t('eticket.footer'), _jsx("br", {}), t(`eticket.team.${mainWebShop}`)] }));
};
